// @flow
import {propOr} from 'ramda'
import CSRFToken from 'utils/MiscUtils/CSRFToken'

const withAuth = (options?: Object): any | RequestOptions => ({
  ...options,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': CSRFToken(),
    ...propOr({}, 'headers', options),
  },
  credentials: 'same-origin',
})

/* eslint import/prefer-default-export: 0 */
export {
  withAuth,
}
